import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { useSearchParams } from "react-router";
import { fetchServCategoryXServCdRange, fetchServiceCategoryHistFact, fetchServiceCodeRangeFact, fetchServicesAll, fetchServiceTypeNames, fetchServices } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import Select from 'react-select';

const limit = 20
const ServiceCodes = () => {

    const [searchParams] = useSearchParams();
    const [searchValue, setSearchValue] = useState(() => searchParams.get("search") || "");
    const [decouncedSearchValue, setDecouncedSearchValue] = useState(() => searchParams.get("search")?.trim() || undefined);

    const [serviceTypeName, setServiceTypeName] = useState(null);

    const { ref, inView } = useInView();

    const { data: serviceTypeNames, isLoading: isLoadingServiceTypeNames } = useQuery({
        queryKey: ['fetchServiceTypeNames'],
        queryFn: async () => {
            const result = await fetchServiceTypeNames();
            return result;
        },
        staleTime: Infinity,
        enabled: true,
    });

    //
    const { data, error, fetchNextPage, hasNextPage, isLoading, isPending, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["serviceCodes", limit, decouncedSearchValue, serviceTypeName],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};

            if (decouncedSearchValue) {
                params.searchText = decouncedSearchValue;
            }

            if (serviceTypeName) {
                params.serviceTypeName = serviceTypeName.value
            }

            return await fetchServices({ ...params, limit });
        },

        select: (data) => {
            //   console.log({ data });
            return { count: data.pages?.[0]?.count, rows: data.pages.map((page) => page.rows).flatMap((x) => x) };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            const hasMore = lastPage?.rows?.length === limit;

            if (!hasMore) return undefined;
            return {
                offset: pages.reduce((accum, page) => {
                    return accum + page.rows.length;
                }, 0),
            };
        },
        staleTime: 0,
        enabled: !!serviceTypeNames,
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const columns = ['serviceCode', 'standardizedServiceCode', 'serviceTypeName', 'serviceShortDesc', 'serviceLongDesc', 'serviceTypeName'];

    const onDetailHandler = async (body) => {
        //TODO diagnosis


        //services
        const range = await fetchServCategoryXServCdRange({
            limit: 100,
            serviceCategoryHistFactKey: body.serviceCategoryHistFactKey
        })

        const rangeTasks = range.rows.map(row => fetchServiceCodeRangeFact({ serviceCodeRangeFactKey: row.serviceCodeRangeFactKey }))
        // if (body.definition.includes('service') && !body.definition.includes('category')) {

        // }
        const ranges = await Promise.all(rangeTasks)

        const codes = await Promise.all(ranges.map(r => fetchServicesAll({ serviceCode: r.rows[0].serviceCodeRangeStart })))
        return { serviceCodes: codes.map(c => c.rows[0]) }
    }

    return (
        <div className={'container '}>
            <p className='title'>Service Codes  ( {data?.count || 0} )</p>
            <p className="sub-title">{serviceTypeNames?.map(stn => stn.serviceTypeName).join(', ')}</p>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    <Select
                        name={'serviceTypeName'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        placeholder={'ServiceType'}
                        // inputRef={field.ref}
                        options={serviceTypeNames?.map(stn => ({ value: stn.serviceTypeName, label: stn.serviceTypeName }))}
                        value={serviceTypeName} // Pass the state variable here
                        onChange={(option) => { setServiceTypeName(option) }}
                    // value={options.find((c) => c.value === field.value)}
                    // onChange={(val) => field.onChange(val.value)}
                    />

                    <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="search..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />
                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem" }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setServiceTypeName(null);
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>

            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"service-code"}
                        columns={columns}
                        items={data?.rows}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading || isLoadingServiceTypeNames}
                        // onEditHandler={onEditHandler}
                        // onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}

        </div>
    )
}

export default ServiceCodes